import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH INSTITUTION LOGO FILES TO EDIT ********************
export const fetchInstitutionLogo = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_INSTITUTION_LOGO_FILES_LOADING,
			payload: true
		});

		const response = await services.get(
			`/assets/${id}/list?model_type=productsgroup&collection=logo`
		);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_INSTITUTION_LOGO_FILES_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_INSTITUTION_LOGO_FILES_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** FETCH INSTITUTION COVER FILES TO EDIT ********************
export const fetchInstitutionCover = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_INSTITUTION_COVER_FILES_LOADING,
			payload: true
		});

		const response = await services.get(
			`/assets/${id}/list?model_type=productsgroup&collection=cover`
		);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_INSTITUTION_COVER_FILES_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_INSTITUTION_COVER_FILES_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
